import { render } from "./getReq.vue?vue&type=template&id=7181877a&scoped=true"
import script from "./getReq.vue?vue&type=script&lang=js"
export * from "./getReq.vue?vue&type=script&lang=js"

import "./getReq.vue?vue&type=style&index=0&id=7181877a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7181877a"]])

export default __exports__